import { useContext, useId, useEffect } from "react";
import { PresenceContext } from "../../context/PresenceContext.js";
function usePresence() {
  const context = useContext(PresenceContext);
  if (context === null)
    return [true, null];
  const { isPresent, onExitComplete, register } = context;
  const id = useId();
  useEffect(() => register(id), []);
  const safeToRemove = () => onExitComplete && onExitComplete(id);
  return !isPresent && onExitComplete ? [false, safeToRemove] : [true];
}
export {
  usePresence
};
//# sourceMappingURL=use-presence.js.map
